import * as Bookmark from "./bookmark";
export { Bookmark };



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/bookmark/index.ts
// module id = 2XqC
// module chunks = 2